/*
 * @Description: 国安中文
 * @Author: zml
 * @Date: 2023-03-23 14:52:59
 * @LastEditors: zml
 * @LastEditTime: 2023-09-18 09:20:15
 */
export default {
    "LLH.login": "登录",
    "LLH.register": "注册",
    "LLH.logout": "退出",
    "LLH.MyOrder": "我的订单",
    "LLH.logoBox.placeholder": "请输入产品关键字",
    "LLH.logoBox.search": "搜索",
    "LLH.logoBox.AdvancedSearch": "高级搜索",
    "LLH.nav.Home": "首页",
    "LLH.nav.Products": "产品",
    "LLH.nav.About": "关于我们",
    "LLH.nav.contact": "联系我们",
    "LLH.nav.news": "新闻",
    "LLH.nav.cart": "购物车",
    "LLH.ViewPrice": "查看价格",
    "LLH.SameFactory": "同一个工厂",
    "LLH.newPro": "最新产品",
    "LLH.AnotherBatch": "换一批",
    "LLH.ViewMore": "查看更多",
    "LLH.hotPro": "热销产品",
    "LLH.hotVidio": "热点视频",
    "LLH.proUnBoxVidio": "开箱视频",
    "LLH.Search": "搜索",
    "LLH.Reset": "重置",
    "LLH.ItemNO": "项目编号",
    "LLH.MTCode": "公司编号",
    "LLH.FTYCode": "出厂货号",
    "LLH.Kind": "种类",
    "LLH.Size": "产品规格",
    "LLH.Price": "价格",
    "LLH.Date": "日期",
    "LLH.Sort": "排序",
    "LLH.DateDesc": "日期降序",
    "LLH.DateAsc": "日期升序",
    "LLH.PriceDesc": "价格降序",
    "LLH.PriceAsc": "价格升序",
    "LLH.NO.Desc": "公司编号降序",
    "LLH.NO.Asc": "公司编号升序",
    "LLH.PleaseEnterTheProductNameKeyword": "请输入产品名称关键字",
    "LLH.PleaseSelect": "请选择",
    "LLH.PleaseLength": "长",
    "LLH.PleaseWidth": "宽",
    "LLH.PleaseHeight": "高",
    "LLH.PleaseMinPrice": "最小价格",
    "LLH.PleaseMaxPrice": "最大价格",
    "LLH.PleaseStartDate": "开始日期",
    "LLH.PleaseEndDate": "结束日期",
    "LLH.UserAccount": "用户名",
    "LLH.password": "密码",
    "LLH.GROUPSEARCH": "综合搜索",
    "LLH.Video_playback": "视频播放",
    "LLH.loginMsg": "访问您的帐户和订单历史记录",
    "LLH.onUserAccount": "没有账号",
    "LLH.SignUp": "立即注册",
    "LLH.ForgetPassword": "忘记密码",
    "LLH.resetPasswords": "重置密码",
    "LLH.emailAddress": "电子邮箱",
    "LLH.verifyCode": "验证码",
    "LLH.getVerifyCode": "获取验证码",
    "LLH.newPassword": "新密码",
    "LLH.confirmPassword": "确认密码",
    "LLH.Submit": "提交",
    "LLH.SignUpAccount": "注册账号",
    "LLH.LoginOnly": "仅用于登录",
    "LLH.Name": "姓名",
    "LLH.NameMsg": "请输入您的姓名，2~30个字符",
    "LLH.passwordMsg": "至少6个字符",
    "LLH.requiredFields": "*必填项",
    "LLH.Email": "邮箱",
    "LLH.EmailMsg": "用于登录，注册后我们将向此邮箱发送邮件以验证有效性",
    "LLH.gender": "性别",
    "LLH.man": "男士",
    "LLH.woman": "女士",
    "LLH.customerSource": "客户来源",
    "LLH.salesman": "销售员",
    "LLH.Country": "国家",
    "LLH.companyName": "公司名称",
    "LLH.duty": "职务",
    "LLH.tel": "电话",
    "LLH.mobile": "手机号",
    "LLH.fax": "传真",
    "LLH.Yahoo": "雅虎",
    "LLH.website": "网站",
    "LLH.address": "地址",
    "LLH.postalCode": "邮政编码",
    "LLH.ExistingAccount": "已有账号",
    "LLH.DirectLogin": "直接登录",
    "LLH.productPrice": "产品价格",
    "LLH.ProductNumber": "产品编号",
    "LLH.Packing": "包装方式",
    "LLH.OuterBoxCBM": "外箱体积",
    "LLH.OuterBoxCUFT": "外箱材积",
    "LLH.Innerboxes": "内盒个数",
    "LLH.OuterQTY": "外箱装量",
    "LLH.GWAndNW": "毛重 / 净重",
    "LLH.productSize": "产品规格",
    "LLH.packageSize": "包装规格",
    "LLH.cartonSize": "外箱规格",
    "LLH.addCart": "添加购物车",
    "LLH.delCart": "移出购物车",
    "LLH.product": "产品",
    "LLH.NewsUpdates": "新闻动态",
    "LLH.ReleaseDate": "发布日期",
    "LLH.MyCart": "我的购物车",
    "LLH.ID": "ID",
    "LLH.picture": "图片",
    "LLH.ArticleNo": "货号",
    "LLH.Description": "名称",
    "LLH.CartOuterQTY": "外箱装量",
    "LLH.CBM": "体积",
    "LLH.CTNS": "箱数",
    "LLH.totalQTY": "总数量",
    "LLH.TotalVolume": "总体积",
    "LLH.total": "合计",
    "LLH.delete": "删除",
    "LLH.checkAll": "全选",
    "LLH.clear": "清空",
    "LLH.totalItems": "总款数",
    "LLH.totalCTNS": "总箱量",
    "LLH.noData": "暂无数据",
    "LLH.totalPrice": "总价",
    "LLH.systemTip": "系统提示",
    "LLH.confirm": "确定",
    "LLH.cancel": "取消",
    "LLH.deleteData": "是否删除该条数据？",
    "LLH.clearCartData": "是否清空全部购物车？",
    "LLH.submitTip": "确认提交订单？",
    "LLH.MyOrder": "我的订单",
    "LLH.PleaseOrderNum": "请输入订单号",
    "LLH.number": "单号",
    "LLH.viewDetails": "查看详情",
    "LLH.orderTime": "创建时间",
    "LLH.linkman": "联系人",
    "LLH.sendDate": "发货时间",
    "LLH.expressNumber": "快递单号",
    "LLH.orderStatus": "订单状态",
    "LLH.unshipped": "未发货",
    "LLH.shipped": "已发货",
    "LLH.SiteNavigation": "网站导航",
    "LLH.ContactUs": "联系我们",
    "LLH.FollowUs": "关注我们",
    "LLH.Landline": "座机",
    "LLH.Email": "邮箱",
    "LLH.Phone": "手机号",
    "LLH.WeChat": "微信号",
    "LLH.Technic": "技术支持",
    "LLH.Software": "深圳宏升软件技术开发有限公司",
    "LLH.detailBtn": "产品详情",
    "LLH.noDetailBtn": "暂无产品详情",
    "LLH.classify": "产品分类",
    "LLH.exclusive": "专属推荐",
    "LLH.loading": "加载中...",
    "LLH.updateTime": "更新时间",
    "LLH.SearchMsg": "以上搜索条件可选任意一项或多项综合搜索",
    "LLH.MessageTitle": "在线提交您的需求",
    "LLH.MessageMsg": "我们将在24小时内回复您的电子邮件，节假日除外",
    "LLH.MessageName": "你的名字",
    "LLH.MessageTel": "你的手机",
    "LLH.MessageEmail": "你的邮箱",
    "LLH.MessageNeeds": "你的需求",
    "LLH.SendInquiry": "发询价单",
    "LLH.EnquiryList": "询价单",
    "LLH.enquiry": "询价",
    "LLH.MyEnquiryList": "我的询价单",
    "LLH.Remark": "备注",
    "LLH.Enquirys": "请留下您的电子邮件，我们会与您联系",
    "LLH.proClass": "产品分类",
    "LLH.submitOrder": "确认提交询单？",
}
